import { render, staticRenderFns } from "./UserComment.vue?vue&type=template&id=f6fd40f2&scoped=true&"
import script from "./UserComment.vue?vue&type=script&lang=js&"
export * from "./UserComment.vue?vue&type=script&lang=js&"
import style0 from "./UserComment.vue?vue&type=style&index=0&id=f6fd40f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fd40f2",
  null
  
)

export default component.exports